import { useState } from 'react';

type FaqItem = { q: string; a: string };

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.q}
            className={`rounded-lg border transition-colors ${
              isOpen ? 'border-primary-300 bg-background-50' : 'border-background-300/60 bg-background-100/60'
            }`}
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="w-full flex items-start justify-between gap-4 text-left px-5 py-4"
            >
              <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                {item.q}
              </span>
              <span
                className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                  isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                }`}
              >
                <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true" />
              </span>
            </button>
            {isOpen && (
              <p className="px-5 pb-5 -mt-1 text-sm md:text-base leading-relaxed text-foreground-700">
                {item.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}